import { NavLink } from "react-router-dom";
import { /*InstagramOutlined, */ FacebookFilled, LinkedinFilled } from "@ant-design/icons";
import { SCREENS } from "../../constants";
import { useWidth } from "../../hooks/useWidth";
import "./style.css";
import { Fragment } from "react";

const socialLinks = [
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/company/yudlagency",
    icon: <LinkedinFilled className="socio-icon" />,
  },
  // { name: "Instagram", link: "#", icon: <InstagramOutlined className="socio-icon" /> },
  { name: "Facebook", link: "https://web.facebook.com/yudl.xyz", icon: <FacebookFilled className="socio-icon" /> },
];

const Footer = () => {
  const { width } = useWidth();

  const isMobile = width < SCREENS.MOBILE;

  return (
    <footer className="yudl-footer d-flex align-items-center">
      <section className="footer-content container-lg container-fluid">
        <div className="footer-section footer-logo">
          <NavLink to={"/"}>
            <img src="/logo-white.png" alt="YUDL" height={isMobile ? 35 : "auto"} />
          </NavLink>
        </div>
        {!isMobile && (
          <Fragment>
            <div className="footer-section copyright">
              <p className="text-start text-md-center">© 2022 YUDL UI Kit. All rights reserved</p>
            </div>
            <div className="footer-section socio-links">
              {socialLinks.map(({ link, name, icon }, i) => (
                <a key={i} title={name} className="yudl-socio-links me-3" href={link} target="_blank" rel="noreferrer">
                  {icon}
                </a>
              ))}
            </div>
          </Fragment>
        )}
        {isMobile && (
          <Fragment>
            <div className="footer-section socio-links">
              {socialLinks.map(({ link, name, icon }, i) => (
                <a key={i} title={name} className="yudl-socio-links me-3" href={link} target="_blank" rel="noreferrer">
                  {icon}
                </a>
              ))}
            </div>
            <div className="footer-section copyright">
              <p className="text-start text-md-center">© {new Date().getFullYear()} YUDL UI Kit. All rights reserved</p>
            </div>
          </Fragment>
        )}
      </section>
    </footer>
  );
};

export default Footer;
